var render = function render() {
  var _vm$contactWay;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      title: _vm.$t("登录失败"),
      maskClosable: false,
      footer: null,
      width: 600
    },
    on: {
      cancel: function ($event) {
        _vm.visible = false;
      }
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", {
    staticClass: "errorCont"
  }, [_c("span", [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle"
    }
  })], 1), _c("div", {
    staticClass: "errorTips"
  }, [_c("div", {
    staticClass: "error"
  }, [_vm._v(" " + _vm._s(_vm.$t("该账号已注销，注销账号30天内")) + _vm._s(_vm.$t("即")) + _vm._s(_vm.$t(_vm.cancellationTime)) + _vm._s(_vm.$t("前可联系官方找回账号。")) + " ")]), _c("div", {
    staticClass: "contactUs",
    domProps: {
      innerHTML: _vm._s((_vm$contactWay = _vm.contactWay) === null || _vm$contactWay === void 0 ? void 0 : _vm$contactWay.copyWriting)
    }
  })])])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };